export const question = [
    {
        id: 1,
        question: "Scheme",
        answerType: "text",
        answer: ["Indo Smallholder Dairy development Finance Scheme"]
    },
    {
        id: 2,
        question: "Purpose",
        answerType: "mixed", 
        answer: {
            intro: "The primary objective of the scheme is to facilitate the development of dairy farms among smallholder farmers through the provision of financing to cover expansion of dairy farms.",
            desc: "Financing will cover:",
            list: [
            "Purchase of dairy animals;",
            "Construction of infrastructure (animal sheds, fencing, pens, etc.);",
            "Purchase of milking and storage equipment; and",
            "Purchase of transportation vehicles/motorbikes"
            ]
        }
    },
    {
        id: 3,
        question: "Eligibility",
        answerType: "mixed", 
        answer: {
            intro: "The following are the eligibility criteria:",
            list: [
            "Smallholder dairy farmers registered with a reputable milk off-taker as a supplier; and",
            "Smallholder dairy farmer to own a minimum of two (2) dairy cows. ",
            "Smallholder dairy farmer to have a minimum of 2 years of experience."
            ]
        }
    },
    {
        id: 4,
        question: "Nature of Facility",
        answerType: "text",
        answer: ["Term Loan"]
    },
    {
        id: 5,
        question: "Amount",
        answerType: "mixed", 
        answer: {
            intro: "The dairy development loan will be for a maximum of:",
            list: [
            "K 40,000 per animal",
            "K 13,200 for construction of animal shed/pen & fencing per unit",
            "K 22,100 for milking & storage equipment per unit",
            "K 84,000 for milk transportation vehicle per vehicle"
            ]
        }
    },
    {
        id: 6,
        question: "Repayment",
        answerType: "mixed",
        answer: {
            intro: "Maximum periods for the loan are broken down as follows:",
            list: [
            "Purchase of dairy animals – maximum tenure of 24 months with a maximum moratorium of 6-months",
            "Construction of infrastructure – maximum tenure of 36 months with a maximum moratorium of 6-months",
            "Purchase of milking & storage equipment and transportation – maximum tenure of 36 months with a maximum moratorium of 6-months",
            "Principal and interest payments on the loan to be serviced monthly",
            "Moratorium may be either interest servicing or non-interest servicing where there is suitable justification",
            "Source of repayment: proceeds from milk sales to reputable milk off-taker who will transfer funds to the borrower's designated IZB account",
            "Dairy farmers must open a DSRA account to facilitate installment buildup where payments are daily, weekly, or bi-weekly. A designated percentage of sales is to be routed to the DSRA account"
            ]
        }
    },
    {
        id: 7,
        question: "Currency",
        answerType: "text",
        answer: ["Currency	The facility will be in Zambian Kwacha (ZMW)."]
    },
    {
        id: 8,
        question: "Margin",
        answerType: "text",
        answer: ["Nil"]
    },
    {
        id: 9,
        question: "Availability of Product",
        answerType: "text",
        answer: ["Available across branch network of the Bank"]
    },
    {
        id: 10,
        question: "Specific Documents",
        answerType: "mixed",
        answer: {
            intro: "The following documents will be required from the borrower:",
            list: [
            "All necessary account opening KYC documents",
            "Documentary evidence of income of the applicant and experience in line of business, if applicable",
            "Valid Invoice for the assets proposed to be purchased from bank finance from the list of Suppliers approved by the Bank",
            "Filled-in Bank loan application supported by letter of recommendation from milk off-taker",
            "Confirmation of ownership rights/right of use of farm land for the tenure of proposed finance.",
            "For Traditional Land, this may include Confirmation from Chief/Headman.",
            "Details of total project and associated costs",
            "Copies of approvals/licenses/permissions from all applicable authorities, which may include WARMA, PACRA, ZRA, etc."
            ]
        }
    }
  ];
   